import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f7ac7554"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["colspan", "onClick"]
const _hoisted_2 = { class: "text" }
const _hoisted_3 = { class: "arrow" }
const _hoisted_4 = ["colspan"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TabularField = _resolveComponent("TabularField")!

  return (_openBlock(), _createBlock(_component_TabularField, {
    class: "basic-table-field-control",
    property: _ctx.property,
    onExecute: _cache[1] || (_cache[1] = c => _ctx.$emit('execute', c))
  }, {
    "table-header": _withCtx(({ columns }) => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(columns, (prop) => {
        return (_openBlock(), _createElementBlock("th", {
          key: prop.id,
          class: "head-cell data-column",
          colspan: _ctx.getColspan(prop),
          onClick: ($event: any) => (_ctx.onSort(prop))
        }, [
          _createElementVNode("span", _hoisted_2, [
            _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.getSortArrow(prop)), 1),
            _createElementVNode("span", null, _toDisplayString(prop.name), 1)
          ])
        ], 8, _hoisted_1))
      }), 128))
    ]),
    "table-row": _withCtx(({ row }) => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, (prop) => {
        return (_openBlock(), _createElementBlock("td", {
          key: prop.id,
          class: "data-column",
          colspan: _ctx.getColspan(prop)
        }, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.getField(prop)), {
            class: "data-field",
            property: prop,
            onExecute: _cache[0] || (_cache[0] = c => _ctx.$emit('execute', c))
          }, null, 40, ["property"]))
        ], 8, _hoisted_4))
      }), 128))
    ]),
    _: 1
  }, 8, ["property"]))
}